// extracted by mini-css-extract-plugin
module.exports = {"coming-soon":"coming-soon-text__coming-soon___35gzg"};